<div *appLoad="let contactUsDocumentUrl of contactUsDocumentUrl$; trackingName: 'nmb-contact-us'">
  <lds-card margin="none" padding="none" (click)="onClick(contactUsDocumentUrl)">
    <div class="support">
      <h4 class="support__heading">We're here to help.</h4>
      <p class="support__text">
        Contact your <span class="support__text__alternate">nMB</span> Team
      </p>
    </div>
  </lds-card>
</div>
